import React from "react";

const experiences = [
  {
    title: "🧑‍💻 Co-Founder & Full Stack Developer",
    company: "📍 Elkhayal Software Company | Remote · Egypt",
    date: "📅 2024 – Present",
    description:
      "Specialized in software engineering and intelligent systems, combining academic excellence with real-world AI applications. Provided a comprehensive foundation in Machine Learning, Deep Learning, NLP, and Computer Vision alongside full-stack development practices.",
    responsibilities: [
      "Co-founded a growing software company focused on impactful web and AI-powered solutions for local and international clients.",
      "Led development and deployment of real-world websites and systems using React, Flask, Node.js, PostgreSQL, and Bootstrap.",
      "Designed responsive UI/UX interfaces and integrated them with secure, scalable backend APIs.",
      {
        text: "Delivered multiple production-ready platforms, including:",
        subList: [
          "Jannaty Support Services – A real estate services website with multilingual support and booking features.",
          "Elesraa Aluminum Products – A company profile website with dynamic galleries, reviews, admin dashboard, and booking system."
        ]
      },
      "Created admin dashboards for content and booking management (FAQs, gallery, reviews, etc.).",
      "Handled system analysis, SRS documentation, deployment, version control (Git), and client communication."
    ]
  },
  {
    title: "🧠 AI Developer & Researcher",
    company: "📍 Freelance Projects & Graduation Work",
    date: "📅 2023 – 2024",
    responsibilities: [
      "Designed and fine-tuned transformer-based models (e.g., BART with LoRA) for summarization and question generation tasks.",
      "Implemented OCR pipelines using Tesseract and OpenCV for extracting text from scanned PDFs and images.",
      "Integrated deep learning models into full-stack apps with Flask, React, and REST APIs.",
      "Created book summarization systems capable of processing PDFs, images, and text into intelligent summaries and assessments."
    ]
  },
  {
    title: "👨‍🏫 Coding Instructor & Mentor",
    company: "📍 Technology Leaders Academy",
    date: "📅 2023 – Present",
    responsibilities: [
      "Taught programming and computer science fundamentals to school and college students.",
      "Covered topics such as frontend development (HTML/CSS/JS) and Python basics.",
      "Mentored junior developers and guided them through project-based learning paths."
    ]
  },
  {
    title: "💼 Software & AI Development Internship",
    company: "📍 Yashfii | Hybrid",
    date: "📅 Aug 2025 – Feb 2026 (6 Months)",
    description:
      "Internship at a medical AI company focused on project-based learning, contributing to real-world AI-powered healthcare applications under professional guidance.",
    responsibilities: [
      "Worked independently on multiple development projects as part of the internship program.",
      "Collaborated with senior developers and medical professionals to design, develop, and test application features.",
      "Participated in hackathon projects aimed at connecting AI with the medical field.",
      "Gained hands-on experience with project-based workflows, version control, and collaborative coding."
    ]
  }
];

const Experience = () => {
  return (
    <section>
      <h1 className="component-title">My Earned Experience via My Journey</h1>
      {experiences.map((exp, index) => (
        <section key={index} className="Container">
          <h1>{exp.title}</h1>
          <div>
            <h5>{exp.company}</h5>
            <h5>{exp.date}</h5>
            {exp.description && <p style={{ textAlign: "left" }}>{exp.description}</p>}
            <section style={{ textAlign: "left" }}>
              <h5>🧠 Key Responsibilities:</h5>
              <ul>
                {exp.responsibilities.map((item, idx) =>
                  typeof item === "string" ? (
                    <li key={idx}>{item}</li>
                  ) : (
                    <li key={idx}>
                      {item.text}
                      <ul>
                        {item.subList.map((subItem, subIdx) => (
                          <li key={subIdx}>{subItem}</li>
                        ))}
                      </ul>
                    </li>
                  )
                )}
              </ul>
            </section>
          </div>
        </section>
      ))}
    </section>
  );
};

export default Experience;
